module.exports = __webpack_public_path__ + "img/background-amplitude.f2b3d017.jpg";